/** Base filter interface */
export interface Filter {
  type: string;
}

/** Filter using a text keyword */
export interface KeywordFilter extends Filter {
  type: "keyword";

  /**
   * The filter input. When `isRegex` is false, this is matched as a single
   * case-insensitive literal substring — spaces and other punctuation are
   * literal characters (matches the behavior of search elsewhere in the
   * web-ui). When `isRegex` is true, this is a regex pattern
   * (case-insensitive) that may be prefixed with `!` to invert matching.
   */
  term: string;

  /** When true, `term` is treated as a regex pattern. */
  isRegex: boolean;
}

/**
 * Initial / "no filter" `KeywordFilter`. Use this at every construction site
 * that needs an unfiltered starting state so future shape changes (e.g.
 * adding `caseSensitive`) update one place instead of three.
 */
export const EMPTY_KEYWORD_FILTER: KeywordFilter = {
  type: "keyword",
  term: "",
  isRegex: false,
};

/**
 * Whether a filter is "empty" — used by both the engine (to short-circuit
 * to the unfiltered list) and the topic tree view (to render the unfiltered
 * regime). The two must agree; routing both callers through this helper
 * is what enforces that.
 */
export function isFilterEmpty(filter: KeywordFilter): boolean {
  return filter.term.trim() === "";
}
